//注意：new Date(timestamp)中传入时间戳的话，timestamp要是13位的时间戳（单位：毫秒）。
function timestampToTime(timestamp) {
    var date = new Date(timestamp); //（时间戳为10位需要*1000），时间戳为13位的话不需要*1000
    // var date = new Date(timestamp*1000); //时间戳为10位需要*1000
//  console.log(date) // 打印结果：Sat Sep 08 2018 09:05:05 GMT+0800 (中国标准时间)
    var Y,M,D,h,m,s;
    Y = date.getFullYear() + "-";
    M = (date.getMonth()+1 < 10 ? "0"+(date.getMonth()+1) : (date.getMonth()+1)) + "-";
    D = (date.getDate() < 10 ? "0"+date.getDate() : date.getDate()) + " ";
    h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
    s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s; //时分秒（h、m、s）可以根据自己的需求加上
}
//  console.log(timestampToTime(timestamp)); // 打印结果：2018-09-08 09:05:05
export default{
	timestampToTime,
}



